import { render } from "./ChatbotPage.vue?vue&type=template&id=72158e8e&ts=true"
import script from "./ChatbotPage.vue?vue&type=script&lang=ts"
export * from "./ChatbotPage.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/mlp/mlp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__